import React from "react";
import "./services.css";
const Services = () => {
  return (
    <>
      <div className="services-page">
        <h5>Services:</h5>
        <h6>Seamless Control with GPS Integration:</h6>
        <span>
          Fraud doesn&#39;t just start at the tow truck; it reverberates through
          every facet of the collision journey, casting a shadow on claims,
          injuries, legal processes, repairs, rentals, towing, and storage. In
          this intricate web, the tow vendor, as the initial triager of the
          scene, wields unparalleled influence, making it the pivotal point for
          insurers to take control.
        </span>
        <h6>Why Protowcall’s Services?</h6>
        <p>Tow Vendor Impact on Claims:</p>
        <span>
          •Recognize the influencers of claims. Our services acknowledge the
          significant impact tow vendors have on claims costs, ensuring a
          proactive approach to mitigate opportunistic fraud and maintain the
          integrity of the entire claims journey.
        </span>
        <p>Comprehensive Fraud Prevention:</p>
        <span>
          Combat fraud on all fronts. Protwocall&#39;s industry-changing
          software is a formidable solution that empowers insurance companies to
          control costs right from the beginning of the claim. By preventing
          fraudulent practices, we safeguard against exploitation at every
          stage, guaranteeing a secure and fraud-resistant environment.
        </span>
        <p>GPS-Enabled Preferred Facility Control:</p>
        <span>
          Take charge of vehicle destinations with precision. Our proprietary
          software, enhanced with GPS integration, gives insurers the capability
          to direct vehicles exclusively to preferred or storage- controlled
          facilities. This advanced feature not only minimizes the risk of
          exploitation but ensures precise control over every aspect of the
          claims process.
        </span>
        <p>Seamless Connectivity:</p>
        <span>
          Unprecedented integration for the first time. Protowcall seamlessly
          connects police, insurers, and tow vendors with minimal input,
          fostering a collaborative environment that streamlines processes and
          sets a new standard for connectivity in the industry. At Protowcall we
          understand that the key to effective collision management is to
          confront fraud head-on.
        </span>
      </div>
    </>
  );
};

export default Services;
